import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Toast } from "react-hot-toast";
import { SafetyPadding } from "../Columns/styles";
import { Flex } from "../Flex";
import { ToastConfig } from "./constants";
export function Toaster({ target, openedDrawerProps, ...flexProps }) {
    const someOpenedDrawer = openedDrawerProps;
    const drawerStyles = {
        maxWidth: typeof someOpenedDrawer?.maxWidth === "string" ? someOpenedDrawer?.maxWidth : "initial",
    };
    const toastStyles = {
        containerClassName: target === "drawer" ? "toast-container-drawer" : "toast-container",
        toastOptions: { duration: ToastConfig.TIME },
        containerStyle: target === "drawer" ? drawerStyles : {},
    };
    const responsiveProps = {
        mobile: someOpenedDrawer ? "collapse" : { medium: "collapse" },
        desktop: someOpenedDrawer ? "collapse" : { small: "collapse", medium: "visible" },
        drawer: someOpenedDrawer ? "visible" : "collapse",
    };
    return (_jsx(Flex, { visibility: responsiveProps[target], zIndex: 9999999, ...flexProps, children: _jsx(SafetyPadding, { verticalPaddings: false, children: _jsx(Toast, { ...toastStyles }) }) }));
}
//# sourceMappingURL=Toaster.js.map